import React from 'react';
import { mapModifiers } from 'src/libs/component';

export interface TextProps {
  children: React.ReactNode;
  type: 'p' | 'span';
  modifiers?: 'error' | 'name';
  bold?: boolean;
  style?: React.CSSProperties;
}

export const Text: React.FC<TextProps> = (props) => {
  const TagName = props.type;

  return (
    <TagName
      className={mapModifiers('a-text', props.type, props.modifiers, props.bold && 'bold')}
      style={props.style}
    >
      {props.children}
    </TagName>
  );
};

Text.defaultProps = {
  type: 'p',
  modifiers: undefined,
  bold: false,
  style: {},
};
